module.exports = __webpack_public_path__ + "img/7.88fe7ea1.png";